/** @jsxImportSource @emotion/react */
import { NewFarm } from '../../components/Home/NewFarm'
import { HomeLayout } from './HomeLayout'

export const HomeFarm = () => {
  return (
    <HomeLayout>
      <NewFarm />
    </HomeLayout>
  )
}
